'use strict';

$(".js-comment-edit").on("click", function (event) {
    event.preventDefault();
    const $editButton = $(this);
    const commentID = $editButton.attr("data-ajax-id");
    const spanID = "#commenttext-row-" + commentID + "-original";
    const commenttext = $(spanID).html();
    const buttonsRow = "#comments-button-" + commentID;
    $("#commenttext-row-" + commentID).hide();
    const editbox = document.createElement("textarea");
    $(editbox).attr("id", "editbox-row-" + commentID);
    $(editbox).attr("class", "mod-editbox");
    $(editbox).attr("rows", "10");
    $(editbox).attr("cols", "80");

    $(editbox).val(commenttext);
    $(spanID).after(editbox);
    $(buttonsRow).hide();

    $("#editcancelbutton-" + commentID).show();
    $("#editsavebutton-" + commentID).show();

    $(spanID).hide();
    return false;
});

$(".js-edit-cancel").on("click", function (event) {
    event.preventDefault();
    const editCancelButton = $(this);
    const commentID = editCancelButton.attr("data-ajax-id");
    const buttonsRow = "#comments-button-" + commentID;
    $("#editbox-row-" + commentID).hide();
    $(editCancelButton).hide();
    $("#editsavebutton-" + commentID).hide();
    $("#approvebutton-" + commentID).show();
    $("#disapprovebutton-" + commentID).show();
    $("#approveplusbutton-" + commentID).show();
    $("#disapproveplusbutton-" + commentID).show();
    $("#editbutton-" + commentID).show();
    $("#commenttext-row-" + commentID).show();
    $(buttonsRow).show();
    return false;
});

$(".js-comment-save").on("click", function (event) {
    event.preventDefault();
    const editSaveButton = $(this);
    const commentID = editSaveButton.attr("data-ajax-id");
    const nodeID = editSaveButton.attr("data-ajax-nodeid");
    const loadingModifier = 'c-button--loading';

    editSaveButton.addClass(loadingModifier);

    $.ajax({
        url: editSaveButton.attr('href'),
        type: "POST",
        data: {
            commentid: commentID,
            nodeid: nodeID,
            commenttext: $("#editbox-row-" + commentID).val()
        },
        success: function (response) {
            const buttonsRow = "#comments-button-" + commentID;
            editSaveButton.removeClass(loadingModifier);

            if (response.status === "success") {
                const spanID = "#commenttext-row-" + commentID + "-original";
                const $commenttext = $("#editbox-row-" + commentID).val();
                $(spanID).html($commenttext);
                $("#commenttext-row-" + commentID).html(response.output);

                $("#editsavebutton-" + commentID).hide();
                $("#editbox-row-" + commentID).remove();
                $("#approvebutton-" + commentID).show();
                $("#approveplusbutton-" + commentID).show();
                $("#disapproveplusbutton-" + commentID).show();
                $("#disapprovebutton-" + commentID).show();
                $("#editbutton-" + commentID).show();
                $("#commenttext-row-" + commentID).show();
                $("#editcancelbutton-" + commentID).hide();
                $(buttonsRow).show();
            } else {
                alert('Saving failed : ' + response.output);
            }
        }
    });

    return false;
});



// WEBPACK FOOTER //
// ./src/js/components/comments-moderation.js